import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import { THEME_COLORS } from "../../utils/Constants";
import FbLoading from "../../assets/images/fbLoading.gif";

const styles = theme => ({
  Loading: {
    height: "100%",
    width: "100%",
    position: "absolute",
    top: "0px"
  },
  backgroundTint: {
    backgroundColor: "#F7F7F",
    position: "relative",
    height: "100%",
    width: "100%"
  },
  LoaderContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%,-50%)"
  },
  Loader: {
    color: THEME_COLORS.ORANGE
  }
});

class Loading extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { classes, customStyles, setBackground } = this.props;
    const { Loading, backgroundTint, LoaderContainer, Loader } = classes;
    let newStyles = { ...customStyles };
    if (setBackground) {
      newStyles["zIndex"] = "1";
    }
    return (
      <div className={Loading} style={newStyles}>
        <div
          className={backgroundTint}
          style={{ backgroundColor: setBackground ? "white" : "#F7F7F" }}
        />
        <div className={LoaderContainer}>
          {/* <CircularProgress size={100} className={Loader} /> */}
          <img src={FbLoading} alt="Loading..." />
          {/* <h2>Loading...</h2> */}
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(Loading);



// WEBPACK FOOTER //
// ./src/components/Utils/Loading.js